import { Communicator } from '../tools/Communication';

export enum IncludeDateParts {
  Hours = 0,
  Seconds = 1,
  Millis = 2,
  Timezone = 3,
}

export function getCurrentDatePlusDays(days: number) {
  return datePlusDays(new Date(Date.now()), days);
}

export function datePlusDays(date: Date, days: number) {
  const dateOut = new Date(date);
  dateOut.setDate(dateOut.getDate() + days);
  return dateOut;
}

/**
 * Gets date part from iso date string (2019-01-31T23:00:00.000Z)
 * @param dateString
 * @returns date part (2019-01-31)
 */
export function getDatePartFromIsoDateString(dateString: string) {
  return dateString.substring(0, 10);
}

/**
 * Gets date part from iso date string (2019-01-31T23:00:00.000Z)
 * @param dateString
 * @returns date part (23:00)
 */
export function getTimePartFromIsoDateString(
  dateString: string,
  include = IncludeDateParts.Hours,
) {
  let end = 16;
  if (include === IncludeDateParts.Seconds) {
    end = 19;
  } else if (include === IncludeDateParts.Millis) {
    end = 23;
  } else if (include === IncludeDateParts.Timezone) {
    end = dateString.length;
  }
  return dateString.substring(11, end);
}

async function getPublicHolidays(
  countryCode: string,
  year: number = new Date().getFullYear(),
) {
  const url = `https://date.nager.at/api/v3/PublicHolidays/${year}/${countryCode}`;
  const holidays = [];
  try {
    const response = await Communicator.Get(
      url,
      {},
      { doNotUsePosingRoleHeader: true },
    );
    const res = await response.json();
    holidays.push(...res);
  } catch (error) {
    console.log(`error getting holidays for ${countryCode}: `, error);
  }
  return holidays;
}

export async function isHoliday(holidays: any[], day: Date = new Date()) {
  const year = day.getFullYear();
  const month = day.getMonth() + 1;
  const dayOfMonth = day.getDate();

  const monthString = month.toString().padStart(2, '0');
  const dayString = dayOfMonth.toString().padStart(2, '0');
  return holidays.some(
    (holiday: any) =>
      holiday.date === `${year}-${monthString}-${dayString}` &&
      holiday.global === true,
  );
}

export async function getWorkingDayAfterNWorkingDays(
  n: number,
  day: Date,
): Promise<Date> {
  n = Math.abs(n);
  const publicHolidays = await getPublicHolidays('DE', day.getFullYear());
  let workingDayAfterNWorkingDays: Date = new Date(day);
  while (
    n > 0 ||
    workingDayAfterNWorkingDays.getDay() === 6 ||
    workingDayAfterNWorkingDays.getDay() === 0 ||
    (await isHoliday(publicHolidays, workingDayAfterNWorkingDays))
  ) {
    if (workingDayAfterNWorkingDays.getDay() === 6) {
      workingDayAfterNWorkingDays = datePlusDays(
        workingDayAfterNWorkingDays,
        2,
      );
    } else if (workingDayAfterNWorkingDays.getDay() === 0) {
      workingDayAfterNWorkingDays = datePlusDays(
        workingDayAfterNWorkingDays,
        1,
      );
    } else if (await isHoliday(publicHolidays, workingDayAfterNWorkingDays)) {
      workingDayAfterNWorkingDays = datePlusDays(
        workingDayAfterNWorkingDays,
        1,
      );
    } else {
      n--;
      workingDayAfterNWorkingDays = datePlusDays(
        workingDayAfterNWorkingDays,
        1,
      );
    }
  }
  return workingDayAfterNWorkingDays;
}
